import { Box, CircularProgress } from '@mui/material';
import { loadingContainerStyles } from './styles';

export function LoadingScreen(): React.JSX.Element {
  return (
    <Box sx={loadingContainerStyles}>
      <CircularProgress />
    </Box>
  );
}
